import http from "../http-common";

class DisponibilidadDataService {
  getAll() {
    return http.get("/disponibilidad");
  }

  getdisponibilidadByDescr(condition, sortfield, sorttype) {
    return http.get(`/disponibilidad/search/?nombredisponibilidad=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  getByUserIdAndCompetenciaId(userid, competenciaid, disponibilidad_active) {
    return http.get(`/disponibilidad/search/?userId=${userid}&competenciaId=${competenciaid}&disponibilidad_active=${disponibilidad_active}`);
  }

  get(id) {
    return http.get(`/disponibilidad/${id}`);
  }

  create(data) {
    return http.post("/disponibilidad/newdisponibilidad", data);
  }

  update(id, data) {
    return http.put(`/disponibilidad/${id}`, data);
  }

  delete(id) {
    return http.delete(`/disponibilidad/${id}`);
  }

  deleteAll() {
    return http.delete(`/disponibilidad`);
  }
}

export default new DisponibilidadDataService();